import {LandIconInfoMarketTile} from '#/components/market-data/land-icon-info-market-tile';
import {useLands} from '#/hooks/query/use-lands';
import {ComponentProps, FunctionComponent} from 'react';
import {useParams} from 'react-router';
import {useQueryParam} from 'use-query-params';

type MarketPriceEmbedQueryParams = Partial<
  Pick<ComponentProps<typeof LandIconInfoMarketTile>, 'thumbnailMode' | 'range'>
>;

export const MarketPriceTickerEmbed: FunctionComponent = () => {
  const {tokenSymbol} = useParams();
  const [thumbnailMode = 'image'] = useQueryParam<MarketPriceEmbedQueryParams['thumbnailMode']>('thumbnailMode');
  const [range = 'monthly'] = useQueryParam<MarketPriceEmbedQueryParams['range']>('range');

  const {data: lands} = useLands();
  const land = lands?.find(land => !!tokenSymbol && land.tokenSymbol === tokenSymbol);

  if (!land) {
    return null;
  }

  return <LandIconInfoMarketTile land={land} range={range} thumbnailMode={thumbnailMode} />;
};
